// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"u0-z","displaySixCardTiles":"v0-z"};